<!-- Zweck: Stellt die HTML-Struktur für shop warenkorb button component im Frontend bereit. -->
<div style="display: inline-block" class="warenkorbbuttonbox">
  @if ((wksvc.primary_warenkorb$|async)) {
    <button #primaryButton (click)="addToPrimaryWarenkorb($event)" (contextmenu)="showMenu($event)"
      class="tut_shopview_artwk"
      [disabled]="disabled || (entry.freimenge == 0 && entry.menge == 0 && entry.aktionsrabattmenge == 0) || !entry.valid || (buttonDisabled|async)"
      mat-icon-button
      matTooltip="Zum Warenkorb '{{(wksvc.primary_warenkorb$|async)?.label}}' hinzufügen. (R-Klick für Auswahl)">
      <svg-icon
        color="{{(disabled || (entry.freimenge == 0 && entry.menge == 0 && entry.aktionsrabattmenge == 0)  || !entry.valid ) ? 'grey' : 'green'}}">
        in-warenkorb
      </svg-icon>
    </button>
  }
</div>

<div style="display: inline-block" class="warenkorbbuttonbox">
  <permission-block [oneOfRoles]="['Vertreter']">
    @if (((vertreterconfig|async)?.DomainVertreterUseDialog && (vertreterconfig|async)?.HasFields)) {
      <button (click)="addToWarenkorbDialog()" class="tut_shopview_artwkvertr"
        (contextmenu)="$event.preventDefault()"
        [disabled]="disabled || (entry.freimenge == 0 && entry.menge == 0 && entry.aktionsrabattmenge == 0) || !entry.valid || (buttonDisabled|async)"
        mat-icon-button
        matTooltip="Mit Kondition hinzufügen. (R-Klick für Auswahl)">
        <svg-icon color="orange">in-warenkorb</svg-icon>
      </button>
    }
  </permission-block>
</div>
